import React from 'react'
import { Link } from 'react-router-dom';
import blueTree from '../../../assets/career.png'
/**
* @author
* @function CareerPage
**/

export const CareerPage = (props) => {
    return (
        <section className="features">
            <div className="insruction">
                {/* Dont remove it */}
            </div>
            <div className="container">
                <div className="all-features flex flex-jc-c">
                    <div className=" flex  flex-jc-c flex-ai-c flex-di-col">
                        <div className="instruction_content">
                            <h1>Come work with us.</h1>
                            <ol>
                                <li className="text-content">
                                   We are try to build more advance features in to this site
                                </li>
                                <li className="text-content">
                                    We are looking for to make a team , we will very happy if you want to join with us and make more improvent in to this site.
                                </li>
                                <li className="text-content">
                                    We looking for react developer , Front-end Developer, Web Designer, UI/UX Designer ,  Back-end Developer , Full-Stack Developer, Digital marketing ,<b>Content Writer</b>  ,  Social Media Handling , Video Editor , Grapic Designer.
                                </li>
                                <li className="text-content">
                                    If you are good in any of these mentioned skill or if you are beginner or just started to learn this skill and want to little more experience. And interested in how the this technology work in actual life. And If you want to explore more any of the mentioned skills you can contact with us and work with us as friend.
                                </li>
                                <li className="text-content">
                                   You can cannect with us on Instagram
                                </li>
                                <a href="https://www.instagram.com/bookssky.in/" target="_blank" className="btn"> Instagram</a>
                            </ol>
                        </div>
                    </div>
                    <div className=" flex  flex-jc-c flex-ai-c flex-di-col">
                        <div className="instruction_images" style={{width:"100%"}}>
                            <img src={blueTree} alt="" />
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}
